import React, { useContext } from 'react';
import { TrustedBy } from 'src/elements/Trusted/TrustedBy';

import { HomeContext } from '../Home';

export default function TrustedSection() {
    const { trusted } = useContext(HomeContext);
    return <TrustedBy items={trusted} />;
}
